import { render } from "./orderHistoryView.vue?vue&type=template&id=92ac09a4"
import script from "./orderHistoryView.vue?vue&type=script&lang=js"
export * from "./orderHistoryView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__